import styled from 'styled-components';

export const LiveFeedAnimationContentWrapper = styled.div``;

export const LiveFeedAnimationWrapper = styled.div`
    height: 0px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-left: -55px;
    padding-left: 55px;
    transition: height 0.3s linear;
`;
